import { commonAPI } from '@/services-ts/axios'
import type { IExcelImportEmployee, IExcelInsertEmployee } from '@/types/Request'
import { defineStore } from 'pinia'

export const useCommonStore = defineStore('common', {
  actions: {
    async GetCountryList() {
      const { status, data } = await commonAPI.CommonServices.GetCountryList()
      return status ? data : []
    },

    async GetCityList(CountryId: string | null = null) {
      const { status, data } = await commonAPI.CommonServices.GetCityList(CountryId)
      return status ? data : []
    },

    async GetTypeList(ParentId: string) {
      const { status, data } = await commonAPI.CommonServices.GetTypeList(ParentId)
      return status ? data : []
    },

    async RemoveCache(CompanyId: string) {
      const { status } = await commonAPI.CommonServices.RemoveCache(CompanyId)
      return status
    },

    async ReIndexElasticSearchEmployees(companyId: string) {
      await commonAPI.CommonServices.ReIndexElasticSearchEmployees(companyId)
    },

    async ReIndexElasticSearchPosts(companyId: string) {
      await commonAPI.CommonServices.ReIndexElasticSearchPosts(companyId)
    },

    async GetIntegrationList() {
      const { status, data } = await commonAPI.CommonServices.GetIntegrationList()
      return status ? data : []
    },

    async RemoveIntegration(appId: string) {
      const { status } = await commonAPI.CommonServices.RemoveIntegration(appId)
      return status
    },

    async ExcelImportEmployee(data: IExcelImportEmployee) {
      const response = await commonAPI.CommonServices.ExcelImportEmployee(data)
      return response
    },

    async ExcelInsertEmployee(data: IExcelInsertEmployee) {
      const response = await commonAPI.CommonServices.ExcelInsertEmployee(data)
      return response
    },
  },
})
